const lang = {
    "zh-cn":{
        'load': '加载中',
        'error': '数据获取中',
        'refresh': '下拉刷新',
        'finish': '完成',
        'loadmore': '上拉加载',
        'Refreshing': '刷新中...',
        'Loading': '加载中...'
    }
}
export{lang}


// WEBPACK FOOTER //
// ./src/assets/js/lang.js